/**
 * Country calling codes for phone number entry.
 * Codes shared by more than one country are listed once with both names so the
 * dial code stays unique - the value only ever needs to be the code itself.
 */
export const COUNTRY_CALLING_CODES = [
  { dialCode: '+1', label: 'United States / Canada' },
  { dialCode: '+61', label: 'Australia' },
  { dialCode: '+55', label: 'Brazil' },
  { dialCode: '+86', label: 'China' },
  { dialCode: '+33', label: 'France' },
  { dialCode: '+49', label: 'Germany' },
  { dialCode: '+91', label: 'India' },
  { dialCode: '+353', label: 'Ireland' },
  { dialCode: '+39', label: 'Italy' },
  { dialCode: '+81', label: 'Japan' },
  { dialCode: '+52', label: 'Mexico' },
  { dialCode: '+64', label: 'New Zealand' },
  { dialCode: '+63', label: 'Philippines' },
  { dialCode: '+65', label: 'Singapore' },
  { dialCode: '+27', label: 'South Africa' },
  { dialCode: '+82', label: 'South Korea' },
  { dialCode: '+34', label: 'Spain' },
  { dialCode: '+44', label: 'United Kingdom' },
  { dialCode: '+84', label: 'Vietnam' }
];

export const DEFAULT_COUNTRY_CALLING_CODE = '+1';
